<template lang="pug">
  #app(:class="($mq === 'pc')? 'is-pc' : 'is-sp'")
    Loading(
      @update-loadingend="UpdateLoadingEnd"
    )
    Header(
      :loadingEnd="loadingEnd"
      :popupShow="popupShow"
      :scrollY="scrollY"
      @update-popupshow="UpdatePopupShow"
    )
    parallax-base(
      v-scroll="UpdateScrollY"
    )
      router-view(
        :loadingEnd="loadingEnd"
        :scrollY="scrollY"
      )
      Footer
    Popup(
      :popupShow="popupShow"
      @update-popupshow="UpdatePopupShow"
    )
</template>

<script>
  import Header from "./layouts/Header"
  import Footer from "./layouts/Footer"
  import Popup from "./components/Popup"
  import Loading from "./components/Loading"
  import ParallaxBase from './components/parallax/ParallaxBase.vue'
  import Scroll from './components/directives/Scroll'

  export default {
    data () {
      return {
        loadingEnd: false,
        popupShow: false,
        scrollY: 0,
        isFullScreen: false,
      }
    },
    head: {
      title() {
        return {
          inner: 'Shampoo Selection',
          separator: '|',
          complement: 'シャンプーセレクション 蔵前美容室',
        }
      }
    },
    name: 'App',
    components: {Header, Footer, Popup, Loading, ParallaxBase},
    methods:{
      UpdateLoadingEnd: function(val){
        this.loadingEnd = val
      },
      UpdatePopupShow: function(val){
        this.popupShow = val
      },
      UpdateScrollY: function (evt, elem) {
        this.scrollY = elem.scrollTop
      }
    },
    directives:{Scroll}
  }

</script>


<style lang="scss">
body {
  background: #000;
  &::-webkit-scrollbar {
    display:none;
  }
}
#app {
  font-family: YuMincho, 'Yu Mincho','Noto Serif JP', serif,'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "palt";
  text-align: center;
  color: #fff;
  line-height: 1.8;
  min-width: 300px;
  font-size: 14px;
  &::-webkit-scrollbar {
    display:none;
  }
  &.is-pc {
    max-width: 500px;
    margin: 0 auto;
  }
  h1,h2,h3,h4 {
    font-family: YuMincho, 'Yu Mincho','Noto Serif JP', serif,'Avenir', Helvetica, Arial, sans-serif;
  }
}
main {
  min-height: 800px;
  padding: 0;
  // margin-top: 67px;
  box-sizing: border-box;
}
button, input, select, textarea {
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  border-radius: 0;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
a {
  color: #fff;
  cursor: pointer;
  text-decoration: underline;
}

h1.title {
  font-size: 48px;
  padding: 24px 0;
  line-height: 1.6;
  > .title-caption {
    font-size: 16px;
    display: block;
  }
}
h2.title {
  font-size: 24px;
  padding: 16px 0;
  letter-spacing: -1.5px;
}
h3.title {
  font-size: 18px;
  padding: 8px 0;
}

img {
  width: 100%;
}

.section {
  margin-bottom: 20px;
}

.page-top-image {
  position: relative;
  height: 320px;
  overflow: hidden;
  .image {
    position: absolute;
    transform: scale(1.25);
    transform-origin: center top;
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.4;
      z-index: 1;
    }
  }
  .text {
    position: absolute;
    width: 100%;
    top: 90px;
  }
}

// .section-box {
//   display: flex;
//   margin-bottom: 20px;
//   > * {
//     width: 50%;
//     align-self: auto;
//   }
//   .item-info {
//     padding: 0 10px;
//   }
// }

.image {
  width: 100%;
}

.box-image {
  margin-bottom: 20px;
  img {
    width: 100%;
  }
}

.button {
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  &.is-default {
    background: #fff;
  }
}

.page {
  &-description {
    margin: 80px 20px 80px;
  }
}

.v-enter {
  opacity: 0;
  &-to {
    opacity: 1;
  }
  &-active{
    transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
  }
}
.v-leave {
  opacity: 1;
  &-to {
    opacity: 0;
  }
  &-active{
    transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue